exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".campaign-datatable{box-shadow:2px 2px 2px -2px #000;background-color:#5c5959f8!important}.country-datatable{box-shadow:2px 2px 2px -2px #000;border-top:3px solid #7a7878;padding:5px!important;background-color:#bdbcbc!important}.country-campaign-has-running{background-color:#70b4038a!important}.country-campaign-all-inactive{background-color:#f0191981!important}.country-campaign-warning{background-color:#f0ec1981!important}.running-campaign{background-color:#70b4038a!important}.countryNameHeader>td{text-align:left;font-weight:bolder;font-size:13px}.no-header>thead{display:none}", ""]);

// exports
